/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetCompanyUserNotificationsResponse,
  GetCurrentCompanyBasicInfoResponse,
  GetCurrentCompanyUserResponse,
  ModelError,
  PostCompanyUserReadNotificationsResponse,
  PostReadNotificationResponse,
} from '../models';
import {
    GetCompanyUserNotificationsResponseFromJSON,
    GetCompanyUserNotificationsResponseToJSON,
    GetCurrentCompanyBasicInfoResponseFromJSON,
    GetCurrentCompanyBasicInfoResponseToJSON,
    GetCurrentCompanyUserResponseFromJSON,
    GetCurrentCompanyUserResponseToJSON,
    ModelErrorFromJSON,
    ModelErrorToJSON,
    PostCompanyUserReadNotificationsResponseFromJSON,
    PostCompanyUserReadNotificationsResponseToJSON,
    PostReadNotificationResponseFromJSON,
    PostReadNotificationResponseToJSON,
} from '../models';

export interface PostReadNotificationRequest {
    notificationId: number;
}

/**
 * 
 */
export class AdminCompanyApi extends runtime.BaseAPI {

    /**
     * ログインしている企業の基本的な情報を返すAPI
     * get current company basic infomation
     */
    async getCurrentCompanyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCurrentCompanyBasicInfoResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/basic_info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCurrentCompanyBasicInfoResponseFromJSON(jsonValue));
    }

    /**
     * ログインしている企業の基本的な情報を返すAPI
     * get current company basic infomation
     */
    async getCurrentCompany(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCurrentCompanyBasicInfoResponse> {
        const response = await this.getCurrentCompanyRaw(initOverrides);
        return await response.value();
    }

    /**
     * ログインしている企業ユーザーの情報を返すAPI
     * get current company user
     */
    async getCurrentCompanyUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCurrentCompanyUserResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_user/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCurrentCompanyUserResponseFromJSON(jsonValue));
    }

    /**
     * ログインしている企業ユーザーの情報を返すAPI
     * get current company user
     */
    async getCurrentCompanyUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCurrentCompanyUserResponse> {
        const response = await this.getCurrentCompanyUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * ログインしている企業ユーザーへの通知情報を返すAPI
     * get notifications for current company user
     */
    async getNotificationsForCurrentCompanyUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompanyUserNotificationsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_user/me/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompanyUserNotificationsResponseFromJSON(jsonValue));
    }

    /**
     * ログインしている企業ユーザーへの通知情報を返すAPI
     * get notifications for current company user
     */
    async getNotificationsForCurrentCompanyUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompanyUserNotificationsResponse> {
        const response = await this.getNotificationsForCurrentCompanyUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * ログインしている企業ユーザーの通知を既読にする
     * post read notification for current company user
     */
    async postReadNotificationRaw(requestParameters: PostReadNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostReadNotificationResponse>> {
        if (requestParameters.notificationId === null || requestParameters.notificationId === undefined) {
            throw new runtime.RequiredError('notificationId','Required parameter requestParameters.notificationId was null or undefined when calling postReadNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_user/me/notifications/{notification_id}`.replace(`{${"notification_id"}}`, encodeURIComponent(String(requestParameters.notificationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostReadNotificationResponseFromJSON(jsonValue));
    }

    /**
     * ログインしている企業ユーザーの通知を既読にする
     * post read notification for current company user
     */
    async postReadNotification(requestParameters: PostReadNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostReadNotificationResponse> {
        const response = await this.postReadNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ログインしている企業ユーザーへの通知を既読にするAPI
     * post read notifications for current company user
     */
    async postReadNotificationsForCurrentCompanyUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostCompanyUserReadNotificationsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_user/me/notifications`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostCompanyUserReadNotificationsResponseFromJSON(jsonValue));
    }

    /**
     * ログインしている企業ユーザーへの通知を既読にするAPI
     * post read notifications for current company user
     */
    async postReadNotificationsForCurrentCompanyUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostCompanyUserReadNotificationsResponse> {
        const response = await this.postReadNotificationsForCurrentCompanyUserRaw(initOverrides);
        return await response.value();
    }

}
